import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex cursor-pointer items-center w-fit mt-6" }
const _hoisted_2 = { class: "ml-2" }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ReportFilter, WorkingHourCurveReportConfig } from "@/types/Report";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkingHourCurveConfig',
  props: {
    config: {},
    filters: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const showMeanWorkingHours = ref(true);

watch(
  () => props.config,
  () => {
    showMeanWorkingHours.value = props.config.show_mean;
  },
  { immediate: true },
);

const getConfig = () => {
  const payload: WorkingHourCurveReportConfig = {
    show_mean: showMeanWorkingHours.value,
  };
  return payload;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500 cursor-pointer",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showMeanWorkingHours).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('configChange', getConfig())))
    }, null, 544), [
      [_vModelCheckbox, showMeanWorkingHours.value]
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("analytics.reports.show_mean_working_hours")), 1)
  ]))
}
}

})